module.exports = __webpack_public_path__ + "media/images/flags/mh-58aed8593cc44a210d7e221b65d4b81e.svg";